import React, { Component } from 'react';
import Helping from "../../helpers/Helping";
import Notification from "../layout/Notification";
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import route from '../../config/routes';
import { MESSAGE, NOTIFICATION } from '../../config/index';
import { API_URL } from '../../config/urls';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import LoadingButton from '../fields/LoadingButton';
import Service from '../../helpers/service';
import { connect } from 'react-redux';

const { TIMER } = NOTIFICATION, { EMPTY, RELEASE, LESS, GREAT } = MESSAGE;

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nft_range: [{ start: "", end: "" }],
            url: API_URL.ADMIN_TRADING_API + route.NFT_RELEASE,
            routeName: route.IMPORT_NFT,
            error_message: '',
            error_type: '',
            time: '',
            isLoading: true,
            btnIsDisable: false
        };

        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        this.setState({ isLoading: false });
        this.props.addCurrentRoute(this.props.profile, this.props.location.pathname);
    }

    handleChange = async (e, index) => {
        const { name, value } = e.target;
        const start_limit = {
            name: 'end range',
            value: this.state.nft_range[index].end.length > 0 ? this.state.nft_range[index].end : 0,
            check: LESS,
        },
            end_limit = {
                name: 'start range',
                value: this.state.nft_range[index].start.length > 0 ? this.state.nft_range[index].start : 0,
                check: GREAT,
            };
        let result = this.state.nft_range;
        if (name === "start") {
            if (start_limit.value > 0) {
                result[index] = {
                    ...result[index], ...await validateField("numeric", name, value, "", 1, "range start", start_limit, true), [name]: value
                };
            }
            else {
                result[index] = {
                    ...result[index], ...await validateField("numeric", name, value, "", 1, "range"), [name]: value
                };
            }

        }
        if (name === "end") {
            if (end_limit.value > 0) {
                result[index] = {
                    ...result[index], ...await validateField("numeric", name, value, "", 1, "range end", end_limit, true), [name]: value
                };
            }
            else {
                result[index] = {
                    ...result[index], ...await validateField("numeric", name, value, "", 1, "range"), [name]: value
                };
            }

        }
        this.setState({ nft_range: result });
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    checkEmptyFields = () => {
        let formHasError = false;
        let currentError = {};

        if (this.state.time.length === 0) {
            this.setState({ ...setErrorFields("time", Helping.getMessageString(EMPTY, "time")) })
            formHasError = true;
        }

        this.state.nft_range.map((currentHash, index) => {
            Helping.removeKeysFromObject(currentHash, ['error_message', "error_end", "btnIsDisable", "error_end_message", "error_start", "error_start_message", "error_type"])

            if (currentHash.start.length === 0) {
                let errorObject = setErrorFields("start", Helping.getMessageString(EMPTY, "range start"));
                currentError = { ...currentError, ...errorObject };
                formHasError = true;
            }
            if (currentHash.end.length === 0) {
                let errorObject = setErrorFields("end", Helping.getMessageString(EMPTY, "range end"));
                currentError = { ...currentError, ...errorObject };
                formHasError = true;
            }
            if (formHasError) {
                this.setState((previousState) => {
                    let updatedTransactionHash = [...previousState.nft_range]
                    updatedTransactionHash[index] = { ...updatedTransactionHash[index], ...currentError }
                    return {
                        nft_range: updatedTransactionHash
                    }
                })
            }
        })
        return formHasError;
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    onSave(e) {
        e.preventDefault();

        let $this = this,
            formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            action: 'set-nfts-release-time',
            nfts_range: this.state.nft_range,
            time: Helping.convertToUnixTime(this.state.time)
        };

        Service.postCall(this.state.url, data).then(response => {
            if (response.data.status === 200) {
                this.setState(
                    {
                        error_message: Helping.getMessageString(RELEASE, "NFT"),
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); this.resetForm() }
                );
            }
        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return $this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => { this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "importing nft")
            }, () => { this.scrollToTop(); })
        });
    }

    handleArrayRemove = (e, index) => {
        e.preventDefault();

        const result = Helping.removeArrayFromIndex(this.state.nft_range, index);
        this.setState({ nft_range: result })
    }

    handleAddElementInArray = (e) => {
        e.preventDefault();

        this.setState((previousState) => {
            return previousState.nft_range.push({ start: "", end: "" });
        })
    }

    handleDateChange = async (e) => {
        const date = e.target.value;

        this.setState({ time: date });
        this.setState({ ...(await validateField('dateTime', 'time', date, '', 1, 'start date')) });
    }

    resetForm = () => {
        this.setState({
            nft_range: [{ start: "", end: "" }],
            btnIsDisable: false,
            error_time_message: "",
            isLoading: true
        })
    }

    render() {
        return (
            <div class="content nft-form">
                <div class="top-header d-block">
                    <div class="header-title">
                        <h2 class="title">Release NFT</h2>
                        <span class="title-caption">You can view your NFT now.</span>
                    </div>
                </div>

                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }
                <div class="main-content">
                    <form action="" class="releaseNFT-form">
                        <div class="form-caption">
                            <label>NFT to Release: </label>
                            <button class="add-form" onClick={(e) => this.handleAddElementInArray(e)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                            </button>
                        </div>

                        <div class="">
                            <div class="transactionHash">

                                {Array.isArray(this.state.nft_range) && this.state.nft_range.map((range, index) => (
                                    <>
                                        <button class="close-form" onClick={(e) => this.handleArrayRemove(e, index)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                        </button>

                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <label for="nftRelStart">Start</label>
                                                    <input type="text" name="start" id="nftRelStart" value={range.start} class={`form-control ${range.error_start_message ? 'error-input' : ''}`} onChange={(e) => this.handleChange(e, index)} />
                                                    <span className="error-msg">{range.error_start_message}</span>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="form-group">
                                                    <label for="nftRelEnd">End</label>
                                                    <input type="text" name="end" id="nftRelEnd" value={range.end} class={`form-control ${range.error_end_message ? 'error-input' : ''}`} onChange={(e) => this.handleChange(e, index)} />
                                                    <span className="error-msg">{range.error_end_message}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ))}

                                <div class="form-group">
                                    <label for="releaseDate">Releasing Date</label>
                                    <input type="datetime-local" name="time" id="releaseDate" min={Helping.currentTimeStampInISO()} value={this.state.time} class={`form-control ${this.state.error_time_message ? 'error-input' : ''}`} onChange={(e) => this.handleDateChange(e)} />
                                    <span className="error-msg">{this.state.error_time_message}</span>
                                </div>

                                <div class="content-btn">
                                    <button type="reset" class="custom-btn sm-btn semi-dark-btn border-btn" onClick={this.resetForm}>Reset</button>
                                    {this.state.btnIsDisable ?
                                        <LoadingButton class_name={"sm-btn"} />
                                        :
                                        <button type="submit" class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.onSave(e)}>{this.state.btnIsDisable ? "Loading..." : "Save"}</button>
                                    }
                                </div>
                            </div>
                        </div>
                    </form>
                    {/* <form action="" class="MiintedItems-form">
                        <h5 class="form-title">Make Preview Items Mintable</h5>
                        <div class="form-caption">
                            <label>Refresh Preview NFT list: </label>
                            <button class="custom-btn icon-btn sm-btn">
                                <svg id="noun_Refresh_2846824" xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
                                    <g id="Group_135" data-name="Group 135" transform="translate(1.124 13.085)"><g id="Group_134" data-name="Group 134" transform="translate(0)"><path id="Path_388" data-name="Path 388" d="M105.3,663.5c-.551,0-1.1,0-1.65,0l-2.618,0h-.6a1.039,1.039,0,0,0-1.023,1.023c0,.551,0,1.1,0,1.65q0,1.308,0,2.616v.6a1.065,1.065,0,0,0,.3.725,1.028,1.028,0,0,0,1.449,0,1.062,1.062,0,0,0,.3-.725c0-.551,0-1.1,0-1.65q0-1.308,0-2.616v-.6l-1.023,1.023c.551,0,1.1,0,1.65,0l2.618,0h.6a1.065,1.065,0,0,0,.725-.3,1.028,1.028,0,0,0,0-1.449,1.079,1.079,0,0,0-.725-.3Z" transform="translate(-99.4 -663.5)"></path></g></g><g id="Group_137" data-name="Group 137" transform="translate(10.033)"><g id="Group_136" data-name="Group 136" transform="translate(0 0)"><path id="Path_389" data-name="Path 389" d="M591.186,29.573c.551,0,1.1,0,1.65,0l2.618,0h.6a1.039,1.039,0,0,0,1.023-1.023c0-.551,0-1.1,0-1.65q0-1.308,0-2.616v-.6a1.065,1.065,0,0,0-.3-.725,1.028,1.028,0,0,0-1.449,0,1.061,1.061,0,0,0-.3.725c0,.551,0,1.1,0,1.65q0,1.308,0,2.616v.6l1.023-1.023c-.551,0-1.1,0-1.65,0l-2.618,0h-.6a1.065,1.065,0,0,0-.725.3,1.028,1.028,0,0,0,0,1.449,1.071,1.071,0,0,0,.725.3Z" transform="translate(-590.162 -22.662)"></path></g></g><g id="Group_139" data-name="Group 139" transform="translate(1.146 8.949)"><g id="Group_138" data-name="Group 138" transform="translate(0)"><path id="Path_390" data-name="Path 390" d="M115.414,462.488a9.114,9.114,0,0,1-.071,1.144l.035-.272a9,9,0,0,1-.556,2.178c.033-.082.065-.164.1-.244a8.787,8.787,0,0,1-1.03,1.883l.15-.207a8.381,8.381,0,0,1-1.454,1.552l.194-.16a7.986,7.986,0,0,1-1.764,1.1l.228-.1a7.614,7.614,0,0,1-2.04.594l.255-.037a7.612,7.612,0,0,1-2.146,0l.255.037a7.67,7.67,0,0,1-2.017-.587l.228.1a8.028,8.028,0,0,1-1.789-1.118l.194.16a8.446,8.446,0,0,1-1.434-1.535l.15.207a8.735,8.735,0,0,1-.64-1.032,1,1,0,0,0-.573-.471.927.927,0,0,0-.738.1,1.025,1.025,0,0,0-.441.612,1.155,1.155,0,0,0,.1.788,9.393,9.393,0,0,0,3.312,3.576,8.463,8.463,0,0,0,8.974-.012,9.355,9.355,0,0,0,3.1-3.218,10.08,10.08,0,0,0,1.331-4.544c.01-.166.013-.33.013-.5a1.1,1.1,0,0,0-.28-.725.92.92,0,0,0-1.358,0,1.14,1.14,0,0,0-.276.727Z" transform="translate(-100.474 -461.462)"></path></g></g><g id="Group_141" data-name="Group 141" transform="translate(0 0.473)"><g id="Group_140" data-name="Group 140" transform="translate(0 0)"><path id="Path_391" data-name="Path 391" d="M46.415,55.283a9.36,9.36,0,0,1,.071-1.136l-.035.272a9.031,9.031,0,0,1,.558-2.178c-.033.082-.065.164-.1.244A8.73,8.73,0,0,1,47.946,50.6l-.15.207a8.368,8.368,0,0,1,1.453-1.549l-.194.16a7.984,7.984,0,0,1,1.764-1.1l-.228.1a7.612,7.612,0,0,1,2.04-.594l-.255.037a7.687,7.687,0,0,1,2.146,0l-.255-.037a7.72,7.72,0,0,1,2.021.59l-.228-.1a7.981,7.981,0,0,1,1.768,1.1l-.194-.16a8.342,8.342,0,0,1,1.44,1.535l-.15-.207a8.593,8.593,0,0,1,.615.98,1,1,0,0,0,.573.471.927.927,0,0,0,.738-.1,1.024,1.024,0,0,0,.441-.612,1.143,1.143,0,0,0-.1-.788A9.336,9.336,0,0,0,57.876,47a8.464,8.464,0,0,0-8.931.037,9.366,9.366,0,0,0-3.085,3.193,10.056,10.056,0,0,0-1.342,4.505c-.012.182-.015.362-.017.544a1.1,1.1,0,0,0,.28.725.92.92,0,0,0,1.357,0,1.118,1.118,0,0,0,.278-.725Z" transform="translate(-44.5 -45.747)"></path></g></g>
                                </svg>
                                <span class="icon-txt">Refresh</span>
                            </button>
                        </div>
                        <div class="form-group">
                            <label for="nftCode">NFT Code</label>
                            <select class="form-select" aria-label="Default select example" id="nftCode">
                                <option value="0" selected></option>
                                <option value="1">One</option>
                                <option value="2">Two</option>
                                <option value="3">Three</option>
                            </select>
                        </div>
                        <div class="content-btn">
                            <button type="reset" class="custom-btn sm-btn semi-dark-btn">Reset</button>
                            <button type="submit" class="custom-btn sm-btn gradiant-btn">Save</button>
                        </div>
                    </form> */}
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    addCurrentRoute
}

export default connect(null, mapDispatchToProps)(Create)